import { ContactsModel } from "../pages/one-way-data/request/requirements-model";
import { TermsAndConditionsModel } from "./common/terms-and-conditions.model";
import { ContainersList } from "./return-container-reference";

export interface ReleaseOrder {
  id?: string;
  is_active?: boolean;
  do_reference_no?: string;
  quantity?: string;
  remaining_pickup_quantity?: string;
  billed_from?: Date | string;
  valid_till?: Date | string;
  storage_charge_currency?: string;
  storage_charge?: number;
  // storage_quantum?: any;
  handling_remarks?: string;
  remarks_revalidation?: string;
  depot?: any;
  requirement?: string;
  revalidation_requested_by?: string;
  revalidation_reason?: string;
  do_owner?: any;
  document?: any;
  upload_document?: any;
  address?: string;
  supplier?: string;
  depot_contact_full_name?: string
  depot_contact_number?: string
  depot_contact_email?: string,
  supply_mappings?: SupplyDOMappings[],
  supply_do?: SupplyDO,
  terms_and_condition_text?: string;
  terms_and_condition_fk?: string;
  contacts?: [];
  container_numbers?:any;
  is_open_do?:boolean;
}

export interface SupplyDOMappings {
  updated_at: string,
  is_active: boolean,
  quantity: string,
  created_by: string,
  updated_by: string,
  supply_do: string
}

export class ReleaseOrderClass implements ReleaseOrder {
  id?: string;
  is_active?: boolean;
  do_reference_no?: string;
  quantity?: string;
  remaining_pickup_quantity?: string;
  billed_from?: Date | string;
  valid_till?: Date | string;
  storage_charge_currency?: string;
  storage_charge?: number;
  // storage_quantum?: any;
  handling_remarks?: string;
  remarks_revalidation?: string;
  depot?: any;
  requirement?: string | any;
  revalidation_requested_by?: string;
  revalidation_reason?: string;
  do_owner?: any;
  document?: any;
  upload_document?: any;
  address?: string;
  depot_contact_full_name?: string;
  depot_contact_number?: string;
  depot_contact_email?: string;
  supplier: string;
  booking_no: string;
  do_number: string;
  supply_mappings?: SupplyDOMappings[];
  supply_do?: SupplyDO;
  terms_and_condition_text?: string;
  terms_and_condition_fk?: string;
  contacts?: any;
  container_numbers:any;
  is_open_do?:boolean;

  constructor() {
    this.id = null;
    this.is_active = true;
    this.do_reference_no = null;
    this.quantity = null;
    this.remaining_pickup_quantity = null;
    this.billed_from = null;
    this.valid_till = null;
    this.storage_charge_currency = null;
    this.storage_charge = null;
    // this.storage_quantum = null;
    this.handling_remarks = null;
    this.remarks_revalidation = null;
    this.depot = null;
    this.requirement = null;
    this.revalidation_requested_by = null;
    this.revalidation_reason = null;
    this.do_owner = null;
    this.document = null;
    this.upload_document = null;
    this.address = null;
    this.depot_contact_full_name = null;
    this.depot_contact_number = null;
    this.depot_contact_email = null;
    this.supplier = null;
    this.booking_no = null;
    this.do_number = null;
    this.supply_mappings = [];
    this.terms_and_condition_fk = null;
    this.terms_and_condition_text = null;
    this.contacts = [];
    this.container_numbers = null;
    this.is_open_do = false;
  }

  saveOrderToModel(data: ReleaseOrder) {
    this.id = data.id;
    this.is_active = data.is_active;
    this.do_reference_no = data.do_reference_no;
    this.quantity = data.quantity;
    this.remaining_pickup_quantity = data.remaining_pickup_quantity;
    this.billed_from = data.billed_from;
    this.valid_till = data.valid_till;
    this.storage_charge_currency = data.storage_charge_currency;
    this.storage_charge = data.storage_charge;
    // this.storage_quantum = data.storage_quantum;
    this.handling_remarks = data.handling_remarks;
    this.storage_charge_currency = data.storage_charge_currency;
    this.storage_charge = data.storage_charge;
    this.remarks_revalidation = data.remarks_revalidation;
    this.revalidation_requested_by = data.revalidation_requested_by;
    this.revalidation_reason = data.revalidation_reason;
    this.depot = data.depot;
    this.do_owner = data.do_owner;
    this.upload_document = data.upload_document;
    this.requirement = data.requirement;
    this.address = data.address;
    this.supplier = data.supplier;
    this.depot_contact_full_name = data.depot_contact_full_name;
    this.depot_contact_number = data.depot_contact_number;
    this.depot_contact_email = data.depot_contact_email;
    this.supply_mappings = data.supply_mappings;
    this.supply_do = data.supply_do;
    this.terms_and_condition_fk = data.terms_and_condition_fk;
    this.terms_and_condition_text = data.terms_and_condition_text;
    this.contacts = data.contacts;
    this.container_numbers = data.container_numbers;
    this.is_open_do = data.is_open_do;

  }

  postReleaseOrder() {
    return {
      is_active: this.is_active,
      do_reference_no: this.do_reference_no,
      quantity: this.quantity,
      remaining_pickup_quantity: this.remaining_pickup_quantity,
      billed_from: this.billed_from,
      valid_till: this.valid_till,
      storage_charge_currency: this.storage_charge_currency,
      storage_charge: this.storage_charge,
      // storage_quantum:this.storage_quantum,
      handling_remarks: this.handling_remarks,
      remarks_revalidation: this.remarks_revalidation,
      revalidation_requested_by: this.revalidation_requested_by,
      revalidation_reason: this.revalidation_reason,
      upload_document: typeof this.upload_document == 'object' && this.upload_document != null ? this.upload_document.id : this.upload_document,

      requirement: this.requirement,
      address: this.address,
      supplier: this.supplier,
      depot_contact_full_name: this.depot_contact_full_name,
      depot_contact_number: this.depot_contact_number,
      depot_contact_email: this.depot_contact_email,
      depot: typeof this.depot == 'object' && this.depot != null ? this.depot.id : this.depot,
      do_owner: typeof this.do_owner == 'object' && this.do_owner != null ? this.do_owner.id : this.do_owner,
      supply_mappings: this.supply_mappings,
      supply_do: this.supply_do,
      terms_and_condition_fk: this.terms_and_condition_fk,
      terms_and_condition_text: this.terms_and_condition_text,
      contacts: this.contacts,
      container_numbers:this.container_numbers
    }
  }
}


export interface SupplierDOModel {
  address: string,
  billed_from: string,
  created_at: string,
  created_by: string,
  depot: string,
  depot_contact_email: string,
  depot_contact_full_name: string,
  depot_contact_number: string,
  do_owner: string,
  do_reference_no: string,
  document: string,
  handling_remarks: string,
  id: string,
  is_active: boolean,
  picked_up_quantity: number,
  quantity: number,
  requirement: string,
  status: string,
  storage_charge: string,
  storage_charge_currency: string,
  storage_quantum: string,
  updated_at: string,
  updated_by: string,
  upload_document: string,
  valid_till: string,
  return_container_references: ContainersList[];
}


export interface SupplyDO {
  id: string
  remaining_pickup_quantity: number
  request: Request
  status: string
  depot: Depot
  available_for_supply_quantity: number
  updated_at: string
  created_at: string
  is_active: boolean
  do_reference_no: string
  quantity: number
  picked_up_quantity: number
  billed_from: string
  valid_till: string
  storage_charge_currency: string
  storage_charge: string
  storage_quantum: string
  handling_remarks: any
  address: string
  depot_contact_full_name: any
  depot_contact_number: any
  depot_contact_email: any
  created_by: string
  updated_by: any
  do_owner: string
  requirement: string
  document: string
  upload_document: string
  supply_do: any
}

export interface Request {
  id: string
  request_type: RequestType
  transaction_type_display: string
  transaction_type: string
  request_number: string
  pols: Pol[]
  pods: Pod[]
  requirement: Requirement[]
  request_date: string
  status: Status
  requestor: Requestor
  is_read: boolean
  chat_thread: string
  external_reference_no: string
  request_source: string
}

export interface RequestType {
  id: string
  updated_at: string
  created_at: string
  is_active: boolean
  name: string
  dev_name: string
  created_by: any
  updated_by: any
}

export interface Pol {
  id: string
  name: string
  display_name: string
  name_display: string
  man_hour_charge: any
}

export interface Pod {
  id: string
  name: string
  display_name: string
  name_display: string
  man_hour_charge: any
}

export interface Requirement {
  id: string
  container_size_type: ContainerSizeType
  condition: Condition
  updated_at: string
  created_at: string
  is_active: boolean
  quantity: number
  leasing_period_years: number
  leasing_period_months: number
  system_remarks: string
  created_by: string
  updated_by: any
  request: string
}

export interface ContainerSizeType {
  id: string
  display: string
  updated_at: string
  created_at: string
  is_active: boolean
  created_by: any
  updated_by: any
  size: string
  type: string
}

export interface Condition {
  id: string
  updated_at: string
  created_at: string
  is_active: boolean
  group: string
  value: string
  description: string
  sequence_no: number
  dev_value: string
  created_by: any
  updated_by: any
}

export interface Status {
  id: string
  default_option_dev_name: string
  updated_at: string
  created_at: string
  is_active: boolean
  name: string
  verb: string
  short_name: string
  dev_name: string
  color: string
  group: any
  allowed_for_internal: boolean
  allowed_for_external: boolean
  action_type: number
  enable_quick_action_button_for_internal: boolean
  enable_quick_action_button_for_external: boolean
  enable_quick_action_link_for_internal: boolean
  enable_quick_action_link_for_external: boolean
  created_by: any
  updated_by: any
  parents: string[]
}

export interface Requestor {
  email: string
  username: string
  first_name: string
  last_name: string
  id: string
  role: string
  user_status: UserStatus
  company: Company
  phone: any
}

export interface UserStatus {
  id: string
  updated_at: string
  created_at: string
  is_active: boolean
  name: string
  description: string
  status_type: number
  dev_name: string
  created_by: any
  updated_by: any
}

export interface Company {
  group: any
  name: string
  legal_name: string
  trade_name: string
  state: string
  address: any
  master_agreement_no: string
  master_agreement_valid_till: any
}

export interface Depot {
  id: string
  name_display: string
  location_type: LocationType
  name: string
  local_name: any
  state: State
  address: string
  location_email: string
  location_contact_no: LocationContactNo
  depot_owner_type: DepotOwnerType
  display_name: string
  contacts: any[]
}

export interface LocationType {
  id: string
  updated_at: string
  created_at: string
  is_active: boolean
  group: string
  value: string
  description: string
  sequence_no: number
  dev_value: string
  created_by: any
  updated_by: any
}

export interface State {
  id: string
  name_display: string
  updated_at: string
  created_at: string
  is_active: boolean
  name: string
  code: any
  created_by: any
  updated_by: any
  country: string
}

export interface LocationContactNo {
  country_code: number
  country: Country
  national_number: number
  as_e164: string
  as_international: string
  as_national: string
  as_rfc3966: string
}

export interface Country {
  id: string
  name_display: string
  flag_url: string
  updated_at: string
  created_at: string
  is_active: boolean
  name: string
  code: string
  isd_code: string
  created_by: any
  updated_by: any
  continent: any
}

export interface DepotOwnerType {
  id: string
  updated_at: string
  created_at: string
  is_active: boolean
  group: string
  value: string
  description: string
  sequence_no: number
  dev_value: string
  created_by: any
  updated_by: any
}
